import {useEffect} from 'react'

import type {CopilotChatMessage} from '../utils/copilot-chat-types'
import {useChatScroll} from './ChatScrollContainer'

interface ChatMessagesGroupProps {
  fillViewport: boolean
  children: React.ReactNode
}

export const ChatMessagesGroup = ({fillViewport, children}: ChatMessagesGroupProps) => {
  const {scrollContainerHeight, scrollToBottom} = useChatScroll()

  useEffect(() => {
    if (fillViewport) scrollToBottom('smooth')
  }, [fillViewport, scrollToBottom])

  return <div style={fillViewport ? {minHeight: scrollContainerHeight} : undefined}>{children}</div>
}

type NotEmptyArray<T> = [T, ...T[]]

/** Each group is a set of user requests followed by assistant responses. */
export function groupChatMessages(messages: CopilotChatMessage[]): CopilotChatMessage[][] {
  return messages.reduce<Array<NotEmptyArray<CopilotChatMessage>>>((groups, message) => {
    const lastGroup = groups.at(-1)
    const lastRole = lastGroup?.at(-1)?.role ?? 'assistant'

    // every time the role changes from assistant to user, create a new group
    if (lastRole === 'assistant' && message.role === 'user') groups.push([message])
    else lastGroup?.push(message)

    return groups
  }, [])
}

try{ ChatMessagesGroup.displayName ||= 'ChatMessagesGroup' } catch {}